
import React from 'react'
import { Search } from 'react-feather'
import IconInput from './IconInput'

/**
 * SearchInput component.
 */

export default function SearchInput({ ...props }) {
  return <IconInput
    icon={Search}
    type="search"
    placeholder="Search"
    {...props} />
}